var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "demo-block" }, [
    _c(
      "div",
      { staticClass: "demo-block-source" },
      [
        _vm._t("source"),
        _vm._v(" "),
        !_vm.$slots.default
          ? _c(
              "span",
              {
                staticClass: "demo-block-code-icon",
                on: {
                  click: function($event) {
                    _vm.showCode = !_vm.showCode
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "code-expand-icon-show",
                  attrs: {
                    alt: "expand code",
                    src:
                      "https://gw.alipayobjects.com/zos/rmsportal/wSAkBuJFbdxsosKKpqyq.svg"
                  }
                })
              ]
            )
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.$slots.default
      ? _c(
          "div",
          { staticClass: "demo-block-meta" },
          [
            _vm._t("default"),
            _vm._v(" "),
            _vm.$slots.default
              ? _c(
                  "span",
                  {
                    staticClass: "demo-block-code-icon",
                    on: {
                      click: function($event) {
                        _vm.showCode = !_vm.showCode
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "code-expand-icon-show",
                      attrs: {
                        alt: "expand code",
                        src:
                          "https://gw.alipayobjects.com/zos/rmsportal/wSAkBuJFbdxsosKKpqyq.svg"
                      }
                    })
                  ]
                )
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showCode,
            expression: "showCode"
          }
        ],
        staticClass: "demo-block-code"
      },
      [
        _c("p", { staticClass: "copy", on: { click: _vm.copy } }, [
          _vm._v("复制")
        ]),
        _vm._v(" "),
        _vm._t("highlight")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/preview/demo-block.vue?vue&type=template&id=77e90763&
// module id = null
// module chunks = 